export function useTripFinderActions({
  emit,
  buildSearchPayload,
  closeMobileRefinePanels,
  isSearchEnabled,
  selectGoOption,
  selectIWantOption,
  setSelectedDestination,
}) {
  const closeModal = () => {
    emit('close');
  };

  const handleLocationSelected = (locationData) => {
    setSelectedDestination(locationData);
  };

  const handleGoOptionSelected = (option) => {
    selectGoOption(option);
    closeMobileRefinePanels();
  };

  const handleIWantOptionSelected = (option) => {
    selectIWantOption(option);
    closeMobileRefinePanels();
  };

  const handleSearch = () => {
    if (!isSearchEnabled.value) return;
    emit('search', buildSearchPayload());
  };

  return {
    closeModal,
    handleGoOptionSelected,
    handleIWantOptionSelected,
    handleLocationSelected,
    handleSearch,
  };
}
